export const AUTH_PROMO_COPY = {
  login: {
    title: "Welcome back",
    subtitle:
      "Compare legends, settle debates, and explore MLB, NBA, and NFL history.",
  },
  register: {
    title: "Join Stats.fan",
    subtitle:
      "Create a free account to compare players, build collections, and back your arguments with real stats.",
  },
};

export const getGoogleAuthUrl = () => {
  const hostname = window.location.hostname;
  const apiBase =
    hostname === "localhost" || hostname === "127.0.0.1"
      ? "http://localhost:8008/api"
      : "/api";
  const frontendOrigin = encodeURIComponent(window.location.origin);
  return `${apiBase}/auth/google?frontend_origin=${frontendOrigin}`;
};

export const getAuthRedirectPath = (searchParams) => {
  const redirect = searchParams.get("redirect");
  if (redirect && redirect.startsWith("/") && !redirect.startsWith("//")) {
    return redirect;
  }
  return "/app";
};

export const buildAuthLink = (path, searchParams) => {
  const redirect = searchParams.get("redirect");
  if (!redirect) return path;
  return `${path}?redirect=${encodeURIComponent(redirect)}`;
};
